import { Component, OnInit, Input,Output ,EventEmitter } from '@angular/core';
import { GlobalService } from '../global.service';
import { Service } from '../services';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
@Component({
  selector: 'app-roles',
  templateUrl: './roles.component.html',
  styleUrls: ['./roles.component.sass']
})
export class RolesComponent implements OnInit {
  public sessionView;
  public tabActive='Manejo de Cuenta';
  public rolesList;
  public selectRole;
  public statusOn=[];
  @Output() nextStep = new EventEmitter<number>();
  public moduleData:any;
  public dataSend:any=[];
  public dataJson;
  constructor(private global:GlobalService,private services: Service,private loadingScreenService :LoadingScreenService, public AngularFireAnalytics:AngularFireAnalytics) {
    this.AngularFireAnalytics.setCurrentScreen("Roles de Usuarios");
    this.AngularFireAnalytics.logEvent("Roles de Usuarios-Screenview");
   }

  ngOnInit() {
    this.global.validateSession();
    this.sessionView=2;
    this.moduleData=JSON.parse(atob(sessionStorage.getItem("moduleData")));
    this.loadingScreenService.startLoading();
    this.services.idRoleList(1).subscribe(data =>{
      this.moduleData=data;
      this.services.rolesList().subscribe(data =>{
        this.loadingScreenService.stopLoading();
        this.rolesList=data;
        this.selectRole=data[0].name;
        for(let i=0;i < this.rolesList.length;i++){
          this.statusOn[i]=false;
        }
      });
    });
  
  }
  updCheck(index,value){
    this.moduleData[index].status=value;
    //alert("change: object["+index+"] ="+value);
  }
  
  changeRole(){
   
  }
  continue(){
    this.dataSend=[this.moduleData.length];
    this.dataJson='[';

    for(var i=0;i<this.moduleData.length;i++){
      this.dataSend[i]=this.moduleData[i].status;
      this.dataJson=this.dataJson+'{'
      this.dataJson=this.dataJson+'"id":'+this.moduleData[i].id_modulo+',';
      this.dataJson=this.dataJson+'"status":'+this.moduleData[i].status;
      if(i==this.moduleData.length-1){
        this.dataJson=this.dataJson+'}';
      }
      else{
        this.dataJson=this.dataJson+'},';
      }
    }

    this.dataJson=this.dataJson+']';
 

    //this.moduleData = JSON.parse('[{"id":1,"name":"Dashboard","status":true,"path":"/home","description":"","role":"admin"},{"id":2,"name":"Manejo de Cuenta","status":true,"path":"/accountmanagement","description":"Ver detalle de cuenta, planes, tarifas, equipos por suscriptor.","role":"admin","child":[{"id":1,"name":"Manejo de Cuenta","status":true,"path":"/accountmanagement","description":"","role":"admin"},{"id":2,"name":"Usuarios y Permisos","status":true,"path":"/usersandpermissions","description":"Crear Usuarios, editar, borrar usuarios. Asignación de roles.","role":"admin"}]},{"id":3,"name":"Pagos y Facturas","status":true,"path":"/billsmanagement","description":"Ver detalles de facturas, histórico de pagos, pagar factura.","role":"admin","child":[{"id":1,"name":"Pagos y Facturas","status":true,"path":"/billsmanagement","description":"","role":"admin"},{"id":2,"name":"Historico de Pagos","status":true,"path":"/paymenthistory","description":"","role":"admin"},{"id":3,"name":"Descarga Tu Factura","status":true,"path":"/billshistory","description":"","role":"admin"}]},{"id":4,"name":"Soporte","status":true,"path":"/frequentquestions","description":"","role":"admin"},{"id":5,"name":"Perfil","status":true,"path":"/profile","description":"Ver detalles de dirección póstal y contacto de la cuenta. Cambiar número de teléfono de contacto, correo electrónico.","role":"admin","child":[{"id":1,"name":"Mi Perfil","status":true,"path":"/profile/1","description":"","role":"admin"},{"id":2,"name":"Mis Cuentas","status":true,"path":"/modifyaccounts","description":"","role":"admin"},{"id":3,"name":"Cambiar Contraseña","status":true,"path":"/profile/3","description":"","role":"admin"},{"id":4,"name":"Actualiza tu Correo Electrónico","status":true,"path":"/profile/2","description":"","role":"admin"}]}]');
   
    
    //this.nextStep.emit(3);
   
  }
  back(){
    this.nextStep.emit(1);
  }
  isOdd(num) { 
    return num % 2;
  }
}
